export const MAP_GEOFENCE_GROUP_HIDE = "MAP_GEOFENCE_GROUP_HIDE";
export const MAP_GEOFENCE_NEW = "MAP_GEOFENCE_NEW";
export const MAP_GEOFENCE_NEW_RESPONSE = "MAP_GEOFENCE_NEW_RESPONSE";
export const MAP_GEOFENCE_RESTART_PROCESS = "MAP_GEOFENCE_RESTART_PROCESS";